import FullNewsCard from './FullNewsCard'

export default FullNewsCard
